export default "__VITE_ASSET__DZcFOZyd__"